import * as React from 'react';
import { useDispatch, useSelector, batch } from 'react-redux';
import { useIsFirstRun } from '@cian/valuation-utils-component';

import {
  setStatusFilter,
  setPage,
  setRoomsFilter,
  getOffersHistorySpoiler,
  getOffersHistoryExists,
} from '../../../actions/offersHistory';
import { selectCategory, selectHouseId } from '../../../selectors/filters';
import { selectDealType, selectIsDesktop } from '../../../selectors/page';
import { FILTER_ALL_VALUE } from '../../../types/offerHistory';
import { TThunkDispatch } from '../../../types/redux';

function useGetUpdateOffersHistorySpoilerAction() {
  const dispatch = useDispatch<TThunkDispatch>();
  const isDesktop = useSelector(selectIsDesktop);
  const category = useSelector(selectCategory);

  return React.useCallback(() => {
    if (isDesktop) {
      dispatch(getOffersHistorySpoiler(category as never));
    } else {
      dispatch(getOffersHistoryExists());
    }
  }, [category, dispatch, isDesktop]);
}

export const useOffersHistoryDataLoading = () => {
  const dispatch = useDispatch();
  const dealType = useSelector(selectDealType);
  const houseId = useSelector(selectHouseId);
  const isFirstRun = useIsFirstRun();
  const updateOffersHistorySpoilerAction = useGetUpdateOffersHistorySpoilerAction();

  /**
   * Если изменилось
   * 1) тип оценки sale | rent
   * 2) id оцениваемого дома
   * сбрасываем пагинатор и фильтры в истории объявлений
   * перезагружаем данные истории объявлений (только для десктопа)
   * При первой загрузке страницы, данные не загружаем, потому что они загружаются на nodejs
   * */
  React.useEffect(() => {
    if (!houseId || isFirstRun) {
      return;
    }

    /**
     * Вызывать getOffersHistorySpoiler только если isDesktop
     */

    batch(() => {
      dispatch(setStatusFilter(FILTER_ALL_VALUE));
      dispatch(setRoomsFilter(FILTER_ALL_VALUE));
      dispatch(setPage(1));
      updateOffersHistorySpoilerAction();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, dealType, houseId]);
};
